import { UI_Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import styles from './NewsList.module.scss';
import classNames from 'classnames';
import ColorOptions, { LinkType } from 'helpers/types';
import { UI_PreviewCardProps } from 'ui/components/2-molecules/Card/PreviewCard/PreviewCard';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_PreviewCardList } from '../PreviewCardList/PreviewCardList';

export interface UI_NewsListProps {
	rootFolderId?: number;
	count?: number;
	offset?: number;
	buttonText?: string;
	bgColor?: ColorOptions;
	filter?: string;
	link?: LinkType;
	newsFetcher?: (
		rootId: number,
		limit: number,
		offset: number,
		filter?: string,
	) => {
		articles?: UI_PreviewCardProps[];
		isLoading: boolean;
	};
}

export const UI_NewsList = ({ rootFolderId, count, offset, buttonText, bgColor, filter, newsFetcher }: UI_NewsListProps) => {
	const rootId = rootFolderId ? rootFolderId : 0;
	const limitQuery = count === 0 ? null : count;
	const offsetQuery = offset >= 0 ? offset : null;
	const newsResult = newsFetcher(rootId, limitQuery, offsetQuery, filter);
	if (newsResult.isLoading) return <UI_Spinner style="large" />;
	if (!newsResult.articles) return <></>;

	return (
		<div className={classNames(styles.NewsList_cards, styles[`u-color___${bgColor}`])}>
			<UI_Container width="Standard">
				<UI_PreviewCardList items={newsResult.articles} desktopWidth="100" mobileWidth="100" buttonText={buttonText} />
			</UI_Container>
		</div>
	);
};
